import React from 'react';

const NotFoundPage = () => {
  return (
    <div style={{textAlign: 'center'}}>
      <p>Nie znaleziono jednostki pod wskazanym adresem. Zweryfikuj wprowadzony adres i spróbuj ponownie.</p>
    </div>
  );
};

export default NotFoundPage;



// WEBPACK FOOTER //
// ./src/components/NotFoundPage.js